import crypto from "./crypto-service.js";
import axios from "axios";

const NetworkService = {
    configuration: {
        baseURL: "/api",
        timeout: 60000,
        headers: {
            'Content-Type': 'application/json'
        }
    },
    get: (url, options) => {
        if (!url) return Promise.reject({ message: "URL for request is empty" });

        const conf = { ...NetworkService.configuration, ...options };

        return axios.get(url, conf);
    },
    post: (url, payload, options) => {
        if (!url) return Promise.reject({ message: "URL for request is empty" });

        const signature = crypto.signPayload(payload);

        url = url.indexOf("?" === -1) ? `${url}?token=${signature}` : `${url}&token=${signature}`;

        const conf = { ...NetworkService.configuration, ...options };

        return axios.post(url, payload, conf);
    },
    put: (url, payload, options) => {
        if (!url) return Promise.reject({ message: "URL for request is empty" });
        const signature = crypto.signPayload(payload);

        url = url.indexOf("?" === -1) ? `${url}?token=${signature}` : `${url}&token=${signature}`;

        const conf = { ...NetworkService.configuration, ...options };

        return axios.put(url, payload, conf);
    },
    patch: (url, payload, options) => {
        if (!url) return Promise.reject({ message: "URL for request is empty" });
        const signature = crypto.signPayload(payload);

        url = url.indexOf("?" === -1) ? `${url}?token=${signature}` : `${url}&token=${signature}`;

        const conf = { ...NetworkService.configuration, ...options };

        return axios.patch(url, payload, conf);
    },
    delete: (url, options) => {
        if (!url) return Promise.reject({ message: "URL for request is empty" });

        const conf = { ...NetworkService.configuration, ...options };

        return axios.delete(url, conf);
    },
    parseEvent: (eventData) => {
        if (!eventData) return null;

        const responses = [];
        const events = eventData.split("\n\n");//fastify trims the \r-s apparently

        events.map(e => {
            const parts = e.split("\n");
            if (parts.length > 1) {
                const event = parts[0].substring(6).trim();
                const data = parts[1].substring(5).trim();
                if (data) {
                    let parsedObject;
                    try {
                        parsedObject = JSON.parse(data);
                    }
                    catch (err) {
                        parsedObject = data;
                    }
                    if (event === "error") {
                        responses.push(typeof (parsedObject) === "string" ? { responseType: "error", text: parsedObject } : parsedObject);
                    } else {
                        responses.push(parsedObject);
                    }
                }
            }
            else if (parts.length === 1) {
                const data = parts[0].substring(5).trim();
                if (data) {
                    let parsedObject;
                    try {
                        parsedObject = JSON.parse(data);
                    }
                    catch (err) {
                        parsedObject = data;
                    }
                    responses.push(parsedObject);
                }
            }
        });

        return responses;
    },
    isDigit: (ch) => {
        return !isNaN(ch);
    },
    isUpperCase: (ch) => {
        if (!ch) return false;
        return ch === ch.toUpperCase() && ch !== ch.toLowerCase();
    },
    isLowerCase: (ch) => {
        if (!ch) return false;
        return ch === ch.toLowerCase() && ch !== ch.toUpperCase();
    },
    respond: async (payload, callbackFnc, $t) => {
        if (!callbackFnc) return;

        try {
            const response = await NetworkService.post(
                `/chat`,
                payload,
                {
                    headers: {
                        ...NetworkService.configuration.headers,
                        Accept: "text/event-stream",
                    },
                    responseType: "stream",
                    adapter: "fetch"
                }
            );


            const reader = response.data
                .pipeThrough(new TextDecoderStream())
                .getReader();
            let mustContinue = true;
            let lastErrorMessage = "";
            let lastInfoMessage = "";
            while (true) {
                const { value, done } = await reader.read();
                if (done) { break; }

                //console.log("Done", done, "Value", value);

                const serverMessages = [];
                const serverResponses = NetworkService.parseEvent(value);
                if (!serverResponses) {
                    console.log("Could not parse server events", value);
                    break;
                }

                //console.log("Server responses", serverResponses);

                serverResponses.map((r) => {
                    if (r.responseType === "completion") {
                        let shouldAddSpace = serverMessages.length > 0 && ((NetworkService.isDigit(r.text[0])
                            && !NetworkService.isDigit(serverMessages[serverMessages.length - 1][serverMessages[serverMessages.length - 1].length - 1]))
                            || (NetworkService.isUpperCase(r.text[0])
                                && NetworkService.isLowerCase(serverMessages[serverMessages.length - 1][serverMessages[serverMessages.length - 1].length - 1])));
                        serverMessages.push(shouldAddSpace ? " " + r.text : r.text);
                    }
                    else if (r.responseType === "error") lastErrorMessage = r.text;
                    else lastInfoMessage = r.text;
                });
                mustContinue = !(serverResponses[serverResponses.length - 1]?.isComplete);
                let newSessionId = serverResponses[serverResponses.length - 1]?.sessionId;
                let context = serverResponses[serverResponses.length - 1]?.context;
                //console.log("Context", context);
                callbackFnc({ completion: serverMessages.join(""), error: lastErrorMessage, info: lastInfoMessage, context }, !mustContinue, newSessionId);
                if (!mustContinue) break;
            }
            if (mustContinue && !lastErrorMessage) {
                //we ended up here due to a break
                callbackFnc({}, true, payload.sessionId);
            }
        } catch (err) {
            callbackFnc(
                { error: $t("pages.chat.chatError") + err.message },
                true,
                payload.sessionId
            );
        }
    }
}

export default NetworkService;